import PaymentStatus from '../enums/paymentStatuses';

const getPaymentBadge = (status) => {
    switch (status) {
        case PaymentStatus.CASHED:
        case PaymentStatus.PROCESSED:
        case PaymentStatus.SWEPT:
        case PaymentStatus.COMPLETED:
            return { modifier: 'active', icon: 'check', iconColor: '#6ECEB2' };
        case PaymentStatus.ISSUED:
            return { modifier: 'info', icon: null };
        case PaymentStatus.ATTEMPTED:
            return { modifier: 'warning', icon: null };
        case PaymentStatus.VOIDED:
        case PaymentStatus.VOID:
            return { modifier: 'pending', icon: null };
        case PaymentStatus.FAILED:
            return { modifier: 'danger', icon: 'x', iconColor: '#DC2626' };
        default:
            return { modifier: 'active', icon: 'check', iconColor: '#6ECEB2' };
    }
};

export default getPaymentBadge;
